<template lang="pug">
button-base.button-primary.font-bold(@click='clickEvent')
  slot
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import ButtonBase from '@/components/atoms/ButtonBase.vue'

/**
 * 基本のボタン
 */
@Component({
  components: {
    ButtonBase,
  },
})
export default class ButtonPrimary extends Vue {
  private clickEvent(key: Event): void {
    this.$emit('click', key)
  }
}
</script>

<style lang="stylus" scoped>
.button-primary
  color var(--color-input-manager-primary__text)
  border 1.5px solid var(--color-input-manager-primary__border)
  border-radius 60px

  &:hover
    color var(--color-input-manager-primary__text-hover)
    background-color var(--color-input-manager-primary__hover)

  &[data-disabled='true']
    color var(--color-input-manager-primary__text-disabled)
    background-color var(--color-input-manager-primary__background-disabled)
    border none
    cursor default
</style>
